(() => {
  const SOURCE_COLLECTIONS = ['best-seller-1'];
  const BADGE_CLASS = 'yl-best-seller-badge';
  const handles = new Set();
  let scheduled = false;

  const productHandleFromHref = (href) => {
    try {
      const url = new URL(href, window.location.origin);
      const match = url.pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : null;
    } catch (_) {
      return null;
    }
  };

  const findMedia = (link) => {
    const standardCard = link.closest('.card-wrapper');
    if (standardCard) {
      return standardCard.querySelector('.card__media') || standardCard.querySelector('.card__inner');
    }

    const scorpioCard = link.closest('[class*="scorpio-card-wrapper-"]') || link.closest('a[class*="scorpio-card-"]');
    if (scorpioCard) {
      return scorpioCard.querySelector('[class*="scorpio-card-media-"]');
    }

    const newCard = link.closest('a[class*="newcol-card-"]');
    if (newCard) {
      return newCard.querySelector('[class*="newcol-media-"]');
    }

    return null;
  };

  const applyBadges = () => {
    scheduled = false;
    if (!handles.size) return;

    document.querySelectorAll('a[href*="/products/"]').forEach((link) => {
      const handle = productHandleFromHref(link.getAttribute('href'));
      if (!handle || !handles.has(handle)) return;

      const media = findMedia(link);
      if (!media || media.querySelector(`.${BADGE_CLASS}`)) return;

      const badge = document.createElement('span');
      badge.className = BADGE_CLASS;
      badge.textContent = 'BEST SELLER';
      badge.setAttribute('aria-hidden', 'true');
      media.prepend(badge);
    });
  };

  const scheduleApply = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(applyBadges);
  };

  const loadSource = async (handle) => {
    const response = await fetch(`/collections/${handle}/products.json?limit=250`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error(`Unable to load ${handle}`);
    const data = await response.json();
    (data.products || []).forEach((product) => {
      if (product && product.handle) handles.add(product.handle);
    });
  };

  const init = async () => {
    try {
      await Promise.all(SOURCE_COLLECTIONS.map(loadSource));
      applyBadges();

      const observer = new MutationObserver(scheduleApply);
      observer.observe(document.body, { childList: true, subtree: true });
    } catch (error) {
      console.warn('[Yalorde] Best Seller badges could not load.', error);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
});

(function(){function addDrawerLogo(){return;var drawer=document.querySelector('.menu-drawer')||document.querySelector('.menu-drawer__inner-container');if(!drawer||drawer.querySelector('.menu-drawer__logo'))return;var src=document.querySelector('.header__heading-logo');if(!src)return;var wrap=document.createElement('div');wrap.className='menu-drawer__logo';wrap.setAttribute('aria-hidden','true');var logo=src.cloneNode(true);logo.removeAttribute('id');wrap.appendChild(logo);drawer.insertBefore(wrap,drawer.firstChild)}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',addDrawerLogo,{once:true})}else{addDrawerLogo()}})();
